import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cinematicUpload: {
    active: false,
    phase: "idle", // idle | animating | waiting | curtain | done
    fileName: "",
    startedAt: null,
    fromCreate: false,
    targetAnalyseId: null, // ID vers lequel naviguer une fois l'animation terminée
    metadataDraft: null,   // Métadonnées à passer via state
    isCompleted: false,
  },
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    startCinematicUpload(state, action) {
      const fileName = action.payload?.fileName || "";
      state.cinematicUpload = {
        active: true,
        phase: "animating",
        fileName,
        startedAt: Date.now(),
        fromCreate: true,
        targetAnalyseId: null,
        metadataDraft: null,
      };
    },
    setCinematicPhase(state, action) {
      const phase = action.payload;
      if (!state.cinematicUpload.active) return;
      state.cinematicUpload.phase = phase;
      state.cinematicUpload.isCompleted = phase === 'curtain';
    },
    setCinematicTarget(state, action) {
      // Appelé quand l'API répond avec l'ID de l'analyse créée
      const { analyseId, metadataDraft } = action.payload || {};
      state.cinematicUpload.targetAnalyseId = analyseId || null;
      state.cinematicUpload.metadataDraft = metadataDraft || null;
      state.cinematicUpload.startedAt = action.payload?.startedAt || state.cinematicUpload.startedAt;
    },
    resetCinematicUpload(state) {
      state.cinematicUpload = { ...initialState.cinematicUpload };
    },
  },
});

export const { startCinematicUpload, setCinematicPhase, setCinematicTarget, resetCinematicUpload } = uiSlice.actions;
export default uiSlice.reducer;
